export const isDate = (stringToTest: string): boolean => {
  //2021-11-26T10:39:32.1
  const UTCFormat = /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d{1,7})?(Z|[+-]\d{2}:\d{2})?)$/;
  return UTCFormat.test(stringToTest);
};

export const containsDate = (item: Record<string, any>): boolean =>
  Object.values(item).some(value => typeof value === 'string' && isDate(value));

//by default we do not want to show seconds - 2021-08-14 07:00
export function UTCDateFormat<T>(item: T, showSeconds = false): T {
  const result = { ...item };

  Object.entries(item).forEach(([key, value]) => {
    if (typeof value === 'string' && isDate(value)) {
      const formattedDate = value.slice(0, showSeconds ? 19 : 16).replace('T', ' ');
      result[key] = formattedDate;
    }
  });
  return result;
}

//by default we do not want to show seconds - 2021-08-14 07:00
export const UTCSingleDate = (value: string, showSeconds = false): string =>
  value && `${value.slice(0, showSeconds ? 19 : 16).replace('T', ' ')}`;
